/**
 * Admin route layout — just the AppShell wrapping nested admin pages.
 *
 * The sidebar already renders an "Admin" section when `isAdmin === true`,
 * so we don't duplicate it here.
 */

import { Outlet } from 'react-router-dom';
import { AppShell } from '../../components/layout/AppShell';

export function AdminLayout() {
  return (
    <AppShell>
      <Outlet />
    </AppShell>
  );
}
